import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { AuditLoginModel } from '../models/userManagementModel/auditlogin.model';

import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { AuthGaurdService } from './auth-gaurd.service';

@Injectable({
  providedIn: 'root'
})
export class AuditLoginService {

  private host = environment.apiUrl + "audit/logins";
  public loggedinUser: string = '';
  public networkId: string = '';
  public email: string = '';
  public employeeId: string = '';
  public created_by: string = '';

  mySalesChannelSet = new Set<string>();
  auditLoginModel = new AuditLoginModel(0, null, '', '', '', '');

  constructor(private http: HttpClient,
    private logger: LoggerService, private authGaurdService: AuthGaurdService) {

  }

  public addLogins(formData: FormData): Observable<AuditLoginModel> {
    return this.http.post<AuditLoginModel>(`${this.host}/addlogins`, formData);
  }

  public getLoginsActivityList(empid: string) {
    let url = this.host + '/getlogins/' + empid;
    return this.http.get<AuditLoginModel[]>(url)
      .pipe(
        map((data: AuditLoginModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public createForm(): FormData {
    this.loggedinUser = this.authGaurdService.loginUser();
    this.networkId = this.authGaurdService.loginNetworkId();
    this.email = this.authGaurdService.loginEmail();
    this.employeeId = this.authGaurdService.loginEmployeeId();
    this.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    //var employee_id = (new Date(auditLoginModel.employee_id)).toUTCString();
    const formData = new FormData();
    formData.append('network_id', this.networkId);
    formData.append('email', this.email);
    formData.append('employee_id', this.employeeId);
    formData.append('created_by', this.created_by);

    //console.log("this.networkId: " + this.networkId);
    //console.log("this.email: " + this.email);
    return formData;
  }

  public getLogins(corps: number[], sc: string, proid: number, dt: Date) {
    const url = this.host + '/getlogins/' + corps + '/' + sc + '/' + proid + '/' + dt;
    console.log("url = " + url);
    return this.http.get<AuditLoginModel[]>(url)
      .pipe(
        map((data: AuditLoginModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

}